"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLocationService = exports.LocationItemToEnum = exports.LocationKeyModeEnum = void 0;
const app_1 = require("app");
const lists_1 = require("../../lists");
var LocationKeyModeEnum;
(function (LocationKeyModeEnum) {
    LocationKeyModeEnum[LocationKeyModeEnum["Code"] = 0] = "Code";
    LocationKeyModeEnum[LocationKeyModeEnum["Title"] = 1] = "Title";
    LocationKeyModeEnum[LocationKeyModeEnum["EnglishTitle"] = 2] = "EnglishTitle";
})(LocationKeyModeEnum || (exports.LocationKeyModeEnum = LocationKeyModeEnum = {}));
var LocationItemToEnum;
(function (LocationItemToEnum) {
    LocationItemToEnum[LocationItemToEnum["FilterAutoCompleteItem"] = 0] = "FilterAutoCompleteItem";
    LocationItemToEnum[LocationItemToEnum["SelectOptionItem"] = 1] = "SelectOptionItem";
})(LocationItemToEnum || (exports.LocationItemToEnum = LocationItemToEnum = {}));
class BaseLocationService {
    get languageCode() {
        const languageCode = app_1.UtilService.parseLanguageCode(this.config.culture);
        if (app_1.UtilService.parseCountryCode(this.config.culture).toLowerCase() === 'tw') {
            return `${languageCode}-HANT`;
        }
        return languageCode;
    }
    get serviceName() {
        return 'BaseLocationService';
    }
    constructor(config) {
        this.config = config;
        this.parseCountryCode = (countyCode) => {
            let result = '';
            if (countyCode) {
                result = countyCode.indexOf(':') !== -1 ? countyCode.split(':')[1] : countyCode;
            }
            return result;
        };
        this.filterOutInvalidTranslation = (translations) => {
            return translations.filter(translation => {
                const isNotFulfilled = !translation.code || !translation.translation;
                if (isNotFulfilled) {
                    // tslint:disable-next-line:no-console
                    console.warn(`[${this.serviceName}]: Not all data is set for item: ${JSON.stringify(translation)}`);
                }
                return !isNotFulfilled;
            });
        };
        this.mapItemsToUIModel = (items, translations, mapItemTo, prefix) => {
            if (!items) {
                return null;
            }
            return items.map(item => {
                const translation = this.getTranslationForItem(translations, item);
                return this.mapToUIItem(item, translation, prefix, mapItemTo);
            });
        };
        this.createAutoCompleteItem = (info, translation) => {
            return {
                internalKey: info.code,
                key: this.getKeyByMode(info, translation),
                value: translation,
            };
        };
        this.createSelectOptionItem = (info, translation) => {
            return {
                title: translation,
                value: this.getKeyByMode(info, translation),
            };
        };
        this.addPrefix = (item, prefix) => {
            if (item) {
                const filterItem = item;
                filterItem.key = `${prefix}:${filterItem.key}`;
                filterItem.internalKey = `${prefix}:${filterItem.internalKey}`;
            }
        };
        this.getKeyByMode = (locationInfo, translation) => {
            switch (this.config.keyMode) {
                case LocationKeyModeEnum.Code:
                    return locationInfo.code;
                case LocationKeyModeEnum.Title:
                    return translation;
                case LocationKeyModeEnum.EnglishTitle:
                    return locationInfo.name;
                default:
                    return locationInfo.code;
            }
        };
    }
    createLocaleStorageKey(prefix) {
        // tslint:disable-next-line:max-line-length
        return `${prefix}_${this.config.culture}_${this.config.prefixNeeded ? 'prefix' : 'noprefix'}_keymode-${this.config.keyMode}`;
    }
    createDefaultStorageKey(prefix) {
        return `${prefix}_default`;
    }
    getTranslationForItem(translations, item) {
        const matchedTranslation = translations
            .filter(translateInfo => translateInfo.code === item.code)
            .map(translateInfo => translateInfo.translation)
            .filter(translation => !!translation);
        return (0, lists_1.getFirstOrDefault)(matchedTranslation, item.name || item.code);
    }
    mapToUIItem(info, translation, prefix, mapItemTo = LocationItemToEnum.FilterAutoCompleteItem) {
        if (mapItemTo === LocationItemToEnum.FilterAutoCompleteItem) {
            return this.mapToFilterAutoCompleteItem(info, translation, prefix);
        }
        return this.mapToSelectOptionItem(info, translation, prefix);
    }
    mapToFilterAutoCompleteItem(info, translation, prefix) {
        const result = this.createAutoCompleteItem(info, translation);
        if (this.config.prefixNeeded) {
            this.addPrefix(result, prefix);
        }
        return result;
    }
    mapToSelectOptionItem(info, translation, prefix) {
        const result = this.createSelectOptionItem(info, translation);
        if (this.config.prefixNeeded) {
            this.addPrefix(result, prefix);
        }
        return result;
    }
}
exports.BaseLocationService = BaseLocationService;
